module.exports = __webpack_public_path__ + "static/img/岸标C43.8b22df99.png";